import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { generate_uuid } from "lib/helpers";
import {
  SelectItem,
  Loading,
  Select,
  TextField,
  CheckBox,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { useWizard } from "store/wizard";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { toJalali, dateTimeToserver, toDatePicker } from "lib/helpers";

const ScreeningCounting = (props) => {
  const wizard = useWizard();
  const [showAddPrice, setShowAddPrice] = useState(false);
  const [prices, setPrices] = useState([]);
  const [cafePlans, setCafePlans] = useState([]);
  const [cafePlanItem, setCafePlanItem] = useState([]);
  const [showAddOwner, setShowAddOwner] = useState(false);
  const [showEditOwner, setShowEditOwner] = useState(false);
  const [ownerItem, setOwnerItem] = useState(false);
  const [showAddCafePlan, setShowAddCafePlan] = useState(false);
  const [showEditCafePlan, setShowEditCafePlan] = useState(false);
  const [owners, setOwners] = useState([]);
  const [showAddActiveTimes, setShowAddPeriod] = useState(false);
  const [showEditActiveTimes, setShowEditPeriod] = useState(false);
  const [activeTimes, SetActiveTimes] = useState([]);
  const [activeTimeItem, SetActiveTimeItem] = useState([]);

  const core = useCore();

  useEffect(() => {
    core.dispatch(core.getProductOwners());
    core.dispatch(core.getCafes());
  }, []);
  useEffect(() => {
    core.dispatch(core.getProductOwners());
    core.dispatch(core.getCafes());
    if (wizard.product && wizard.product.prices) {
      setPrices(
        wizard.product.prices.map((i) => ({
          uuid: i.id,
          currency: i.currency,
          amount: i.amount,
          status: i.status,
        }))
      );
    }
    if (wizard.product && wizard.product.product_owners) {
      setOwners(
        wizard.product.product_owners.map((i) => ({
          uuid: i.id,
          user_id: i.user && { value: i.user.id, label: i.user.complete_name },
          share_in_sales_prcent: i.share_in_sales_prcent,
        }))
      );
    }
    if (wizard.product && wizard.product.cafe_plans) {
      setCafePlans(
        wizard.product.cafe_plans.map((i) => ({
          uuid: i.id,
          cafe_id: i.cafe && { value: i.cafe.id, label: i.cafe.complete_name },
          capacity: i.capacity,
          price: i.price,
          status: i.status,
          screening_start_at: toDatePicker(i.screening_start_at),
        }))
      );
    }

    if (wizard.product && wizard.product.product_active_times) {
      SetActiveTimes(
        wizard.product.product_active_times.map((i) => ({
          uuid: i.id,
          ...(!i.for_ever &&
            i.active_from && { active_from: toDatePicker(i.active_from) }),
          ...(!i.for_ever &&
            i.active_to && { active_to: toDatePicker(i.active_to) }),
          language: i.language,
          show_counter: i.show_counter,
          for_ever: i.for_ever,
          type: i.type,
        }))
      );
    }
  }, [wizard.product]);

  const _renderPrices = () => {
    return prices.map((item, index) => (
      <div key={`item_${index}`} className="grid grid-cols-4 gap-3">
        <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
        <h5 className="text-center">{item.amount}</h5>
        <h5 className="text-center">
          <button
            type="button"
            className={`btn btn-sm ${
              item.status ? "btn-success" : "btn-danger"
            }`}
            onClick={() => {
              setPrices([
                ...prices.filter((i) => i.uuid !== item.uuid),
                { ...item, status: !item.status },
              ]);
            }}
          >
            {item.status ? "فعال" : "غیرفعال"}
          </button>
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setPrices(prices.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  const _renderCafePlans = () => {
    return cafePlans.map((item, index) => (
      <div key={`item_${index}`} className="grid grid-cols-6 gap-3">
        <h5 className="text-xs">{item.cafe_id && item.cafe_id.label}</h5>
        <h5>{toJalali(item.screening_start_at, "jYYYY-jMM-jDD h:mm")}</h5>
        <h5>{item.price}</h5>
        <h5>{item.capacity}</h5>
        <h5 className="text-center">
          <button
            type="button"
            className={`btn btn-sm ${
              item.status ? "btn-success" : "btn-danger"
            }`}
            onClick={() => {
              setCafePlans([
                ...cafePlans.filter((i) => i.uuid !== item.uuid),
                { ...item, status: !item.status },
              ]);
            }}
          >
            {item.status ? "فعال" : "غیرفعال"}
          </button>
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setCafePlanItem(item);
              setShowEditCafePlan(true);
            }}
            className="btn btn-sm btn-warning  mx-2"
          >
            ویرایش
          </button>
          <button
            type="button"
            onClick={() => {
              setCafePlans(cafePlans.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  const activeTimesType = {
    Activation: "نمایش در سایت",
    Screening: "اکران",
    TicketSelling: "بلیت فروشی",
  };

  const _renderActiveTimes = () => {
    return activeTimes.map((item, index) => (
      <div key={`item_${index}`} className="grid grid-cols-6 gap-2">
        <h5>{activeTimesType[item.type]}</h5>
        {item.for_ever ? (
          <>
            <h5>برای همیشه</h5>
            <h5></h5>
          </>
        ) : (
          <>
            <h5>{toJalali(item.active_from, "jYYYY-jMM-jDD HH:mm:ss")}</h5>
            <h5>{toJalali(item.active_to, "jYYYY-jMM-jDD HH:mm:ss")}</h5>
          </>
        )}

        <h5 className="text-center">
          {item.language == "fa" ? "فارسی" : "انگلیسی"}
        </h5>
        <h5 className="text-center">
          {item.show_counter ? "فعال" : "غیرفعال"}
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              SetActiveTimeItem(item);
              setShowEditPeriod(true);
            }}
            className="btn btn-sm btn-warning  mx-2"
          >
            ویرایش
          </button>
          <button
            type="button"
            onClick={() => {
              SetActiveTimes(activeTimes.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  const _renderOwners = () => {
    return owners.map((item, index) => (
      <div key={`index_${index}`} className="grid grid-cols-5 gap-3">
        <h5 className="col-span-3">{item.user_id && item.user_id.label}</h5>
        <h5 className="text-center">{item.share_in_sales_prcent}</h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setOwnerItem(item);
              setShowEditOwner(true);
            }}
            className="btn btn-sm btn-warning  mx-2"
          >
            ویرایش
          </button>
          <button
            type="button"
            onClick={() => {
              setOwners(owners.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  if (wizard.load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AddPrices
        close={() => setShowAddPrice(false)}
        show={showAddPrice}
        submit={(values) => {
          setPrices([...prices, values]);
        }}
      />
      <AddOwners
        close={() => setShowAddOwner(false)}
        show={showAddOwner}
        submit={(values) => {
          setOwners([...owners, values]);
        }}
      />
      <EditOwners
        close={() => setShowEditOwner(false)}
        show={showEditOwner}
        item={ownerItem}
        submit={(values) => {
          setOwners([
            ...owners.filter((i) => i.uuid !== ownerItem.uuid),
            values,
          ]);
        }}
      />
      <AddPeriods
        close={() => setShowAddPeriod(false)}
        show={showAddActiveTimes}
        submit={(values) => {
          SetActiveTimes([...activeTimes, values]);
        }}
      />
      <EditPeriods
        close={() => setShowEditPeriod(false)}
        show={showEditActiveTimes}
        item={activeTimeItem}
        submit={(values) => {
          SetActiveTimes([
            ...activeTimes.filter((i) => i.uuid !== activeTimeItem.uuid),
            values,
          ]);
        }}
      />

      <AddCafePlans
        close={() => setShowAddCafePlan(false)}
        show={showAddCafePlan}
        submit={(values) => {
          setCafePlans([...cafePlans, values]);
        }}
      />
      <EditCafePlans
        close={() => setShowEditCafePlan(false)}
        show={showEditCafePlan}
        item={cafePlanItem}
        submit={(values) => {
          setCafePlans([
            ...cafePlans.filter((i) => i.uuid !== cafePlanItem.uuid),
            values,
          ]);
        }}
      />
      <div className="font-medium text-base">قیمت و فعالسازی</div>
      <Formik
        key="fromik_p_counting"
        initialValues={{
          prices: [],
          product_owners: [],
          active_times: [],
          cafe_plans: [],
          vod_selling_type: wizard.product.vod_selling_type,
          sell_by_others: wizard.product.sell_by_others,
        }}
        onSubmit={async (values, { setSubmitting }) => {
          await props.submitStep({
            prices: prices,
            vod_selling_type: values.vod_selling_type,
            sell_by_others: values.sell_by_others,
            product_owners: owners.map((i) => ({
              user_id: i.user_id.value,
              share_in_sales_prcent: i.share_in_sales_prcent,
            })),
            cafe_plans: cafePlans.map((i) => ({
              uuid: i.uuid,
              cafe_id: i.cafe_id.value,
              capacity: i.capacity,
              price: i.price,
              status: i.status,
              screening_start_at: dateTimeToserver(i.screening_start_at),
            })),
            active_times: activeTimes.map((i) => ({
              for_ever: i.for_ever,
              language: i.language,
              show_counter: i.show_counter,
              type: i.type,
              ...(i.active_from && {
                active_from: dateTimeToserver(i.active_from),
              }),
              ...(i.active_to && { active_to: dateTimeToserver(i.active_to) }),
            })),
          });
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
              {wizard.type == "CafeScreening" && (
                <div className="intro-y col-span-12 border rounded p-2 border-theme-21">
                  <div className="flex justify-between items-center">
                    <h2>برنامه فروش کافه ها :</h2>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => setShowAddCafePlan(true)}
                    >
                      افزودن
                    </button>
                  </div>
                  <hr className="my-2" />
                  <div className="grid grid-cols-1 gap-4 mt-3">
                    <div className="grid grid-cols-6 gap-3">
                      <h5>کافه </h5>
                      <h5 className="text-center">تاریخ</h5>
                      <h5 className="text-center">قیمت</h5>
                      <h5 className="text-center">ظرفیت</h5>
                      <h5 className="text-center">وضعیت</h5>
                      <div className="flex justify-center items-center">
                        عملیات
                      </div>
                    </div>
                    {_renderCafePlans()}
                  </div>
                </div>
              )}

              <div className="intro-y col-span-12 border rounded p-2 border-theme-21">
                <div className="flex justify-between items-center">
                  <h2>سهم صاحبان اثر :</h2>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowAddOwner(true)}
                  >
                    افزودن
                  </button>
                </div>
                <hr className="my-2" />
                <div className="grid grid-cols-1 gap-4 mt-3">
                  <div className="grid grid-cols-3 gap-3">
                    <h5>نام </h5>
                    <h5 className="text-center">درصد سهم</h5>
                    <div className="flex justify-center items-center">
                      عملیات
                    </div>
                  </div>
                  {_renderOwners()}
                </div>
              </div>

              <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                <button
                  className="btn btn-secondary w-24"
                  type="button"
                  onClick={() => {
                    wizard.dispatch(wizard.previous());
                  }}
                  disabled={isSubmitting}
                >
                  قبلی
                </button>
                <button
                  className="btn btn-primary w-24 mr-2"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                {wizard && wizard.mode == "update" && (
                  <button
                    className="btn btn-secondary w-24 mr-2"
                    type="button"
                    onClick={() => {
                      wizard.dispatch(wizard.next());
                    }}
                    disabled={isSubmitting}
                  >
                    بعدی
                  </button>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ScreeningCounting;

export function AddPrices(props) {
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن قیمت">
      <Formik
        key="fromik_p_price"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="">
                  <Field
                    placeholder="واحد پولی"
                    label="واحد پولی :"
                    name="currency"
                    component={Select}
                    options={[
                      { value: "IRR", label: "تومان" },
                      { value: "USD", label: "دلار" },
                    ]}
                  />
                </div>
                <div className="">
                  <Field
                    placeholder="مقدار"
                    label="مقدار :"
                    name="amount"
                    component={TextField}
                  />
                </div>
                <div className="">
                  <Field label="وضعیت" name="status" component={CheckBox} />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddOwners(props) {
  const core = useCore();
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن سهام دار">
      <Formik
        key="fromik_p_prices"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-4 md:gap-3">
                <div className="col-span-3">
                  <Field
                    placeholder="کارگردان"
                    label="کارگردان :"
                    name="user_id"
                    component={SelectItem}
                    options={core.productOwners || []}
                  />
                </div>
                <div className="col-span-1">
                  <Field
                    placeholder="درصد"
                    label="درصد همکاری:"
                    type="number"
                    name="share_in_sales_prcent"
                    component={TextField}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function EditOwners(props) {
  const core = useCore();
  return (
    <Modal show={props.show} handleClose={props.close} title="ویرایش سهام دار">
      <Formik
        key="fromik_pe_owners"
        initialValues={props.item}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-4 md:gap-3">
                <div className="col-span-3">
                  <Field
                    placeholder="کارگردان"
                    label="کارگردان :"
                    name="user_id"
                    component={SelectItem}
                    options={core.productOwners || []}
                  />
                </div>
                <div className="col-span-1">
                  <Field
                    placeholder="درصد"
                    label="درصد همکاری:"
                    type="number"
                    name="share_in_sales_prcent"
                    component={TextField}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddPeriods(props) {
  const wizard = useWizard();
  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="افزودن بازه زمانی"
    >
      <Formik
        key="fromik_p_periods"
        initialValues={{
          uuid: generate_uuid(),
          for_ever: false,
          type: "Activation",
        }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values, setFieldValue, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                <div className="col-span-12 grid md:grid-cols-3 md:gap-3">
                  <div>
                    <Field
                      placeholder="برای همیشه"
                      label="برای همیشه"
                      name="for_ever"
                      component={CheckBox}
                    />
                  </div>
                  <div className="">
                    <Field
                      placeholder="در زبان"
                      label="در زبان :"
                      name="language"
                      component={Select}
                      options={[
                        { value: "fa", label: "فارسی" },
                        { value: "en", label: "انگلیسی" },
                      ]}
                    />
                  </div>
                  {wizard.type == "Screening" && (
                    <>
                      <div className="">
                        <Field
                          placeholder="نوع"
                          label="نوع :"
                          name="type"
                          component={Select}
                          options={[
                            { value: "Activation", label: "نمایش در سایت" },
                            { value: "Screening", label: "اکران" },
                            { value: "TicketSelling", label: "بلیت فروشی" },
                          ]}
                          validate={(value) =>
                            validationWrapper(value, required)
                          }
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="نمایش کانتر"
                          label="نمایش کانتر"
                          name="show_counter"
                          component={CheckBox}
                          mydisabled={true}
                        />
                      </div>
                    </>
                  )}
                </div>
                {values && values.for_ever == false && (
                  <>
                    <div className="">
                      <Field
                        placeholder="از"
                        label="از :"
                        name="active_from"
                        component={PersianDataPicker}
                        hasTime={true}
                        format="YYYY/MM/DD HH:mm:ss"
                      />
                    </div>

                    <div className="">
                      <Field
                        placeholder="تا"
                        label="تا :"
                        name="active_to"
                        component={PersianDataPicker}
                        hasTime={true}
                        format="YYYY/MM/DD HH:mm:ss"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function EditPeriods(props) {
  const wizard = useWizard();
  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="ویرایش بازه زمانی"
    >
      <Formik
        key="fromik_pe_periods"
        initialValues={props.item}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values, setFieldValue, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                <div className="col-span-12 grid md:grid-cols-3 md:gap-3">
                  <div>
                    <Field
                      placeholder="برای همیشه"
                      label="برای همیشه"
                      name="for_ever"
                      component={CheckBox}
                    />
                  </div>
                  <div className="">
                    <Field
                      placeholder="در زبان"
                      label="در زبان :"
                      name="language"
                      component={Select}
                      options={[
                        { value: "fa", label: "فارسی" },
                        { value: "en", label: "انگلیسی" },
                      ]}
                    />
                  </div>
                  {wizard.type == "Screening" && (
                    <>
                      <div className="">
                        <Field
                          placeholder="نوع"
                          label="نوع :"
                          name="type"
                          component={Select}
                          options={[
                            { value: "Activation", label: "نمایش در سایت" },
                            { value: "Screening", label: "اکران" },
                            { value: "TicketSelling", label: "بلیت فروشی" },
                          ]}
                          validate={(value) =>
                            validationWrapper(value, required)
                          }
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="نمایش کانتر"
                          label="نمایش کانتر"
                          name="show_counter"
                          component={CheckBox}
                          mydisabled={true}
                        />
                      </div>
                    </>
                  )}
                </div>
                {values && values.for_ever == false && (
                  <>
                    <div className="">
                      <Field
                        placeholder="از"
                        label="از :"
                        name="active_from"
                        component={PersianDataPicker}
                        hasTime={true}
                        format="YYYY/MM/DD HH:mm:ss"
                      />
                    </div>

                    <div className="">
                      <Field
                        placeholder="تا"
                        label="تا :"
                        name="active_to"
                        component={PersianDataPicker}
                        hasTime={true}
                        format="YYYY/MM/DD HH:mm:ss"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddCafePlans(props) {
  const core = useCore();
  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="افزودن برنامه کافه"
    >
      <Formik
        key="fromik_p_cafe_plans"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-4 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="کافه"
                    label="کافه :"
                    name="cafe_id"
                    component={SelectItem}
                    options={core.cafes || []}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="زمان"
                    label="زمان :"
                    name="screening_start_at"
                    component={PersianDataPicker}
                    hasTime={true}
                    format="YYYY/MM/DD HH:mm:ss"
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="قیمت"
                    label="قیمت :"
                    type="number"
                    name="price"
                    component={TextField}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="ظرفیت"
                    label="ظرفیت :"
                    type="number"
                    name="capacity"
                    component={TextField}
                  />
                </div>

                <div className="col-span-2">
                  <Field
                    placeholder="وضعیت"
                    label="وضعیت"
                    name="status"
                    component={CheckBox}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function EditCafePlans(props) {
  const wizard = useWizard();
  const core = useCore();
  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="ویرایش برنامه کافه"
    >
      <Formik
        key="fromik_pe_cafe_plans"
        initialValues={props.item}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values, setFieldValue, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-4 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="کافه"
                    label="کافه :"
                    name="cafe_id"
                    component={SelectItem}
                    options={core.cafes || []}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="زمان"
                    label="زمان :"
                    name="screening_start_at"
                    component={PersianDataPicker}
                    hasTime={true}
                    format="YYYY/MM/DD HH:mm:ss"
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="قیمت"
                    label="قیمت :"
                    type="number"
                    name="price"
                    component={TextField}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="ظرفیت"
                    label="ظرفیت :"
                    type="number"
                    name="capacity"
                    component={TextField}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="وضعیت"
                    label="وضعیت"
                    name="status"
                    component={CheckBox}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
